/* eslint-disable react/prop-types */
import React from 'react';
import CSSModules from 'react-css-modules';

import { USER_STATUSES } from '../../../constants/strings';

import styles from './index.styl';

const Hover = ({ status }) => {
  const userStatus = USER_STATUSES.find(item => item.status === status);

  return <div styleName="hover">{userStatus && userStatus.text}</div>;
};

export default CSSModules(Hover, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/StatusIndicator/Hover.jsx